import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HubMstApi } from '../api/hub-mst.api';
import { HubMst, HubMstData } from '../../../interfaces/masters/hub-mst';

@Injectable()
export class HubMstService extends HubMstData {

  constructor(private api: HubMstApi) {
    super();
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  getById(url: string): Observable<HubMst> {
    return this.api.getById(url);
  }

  create(url: string, data: HubMst): Observable<any> {
    return this.api.add(url, data);
  }

  update(url: string, data: HubMst): Observable<any> {
    return this.api.update(url, data);
  }

}
